import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import Vega from './Vega';
/**
 * Syntactic sugar for using vega-lite with Vega
 * @param props
 */

export default function VegaLite(props) {
  return (
    /*#__PURE__*/
    React.createElement(Vega, _extends({}, props, {
      mode: "vega-lite"
    }))
  );
}